import { ToolbarIconButton } from "@-/dev.improve.haniverse.components.ui.toolbar.button.icon";
import { ActionMenu } from "@-/dev.improve.haniverse.components.ui.action-menu";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";

export function LearnSummaryReviewOptionsMenu() {
  const [introduceNewCardsEnabled, setIntroduceNewCardsEnabled] = useDeviceSetting(
    "introduceNewCardsEnabled",
  );

  return (
    <ActionMenu
      align="end"
      items={[
        {
          checked: introduceNewCardsEnabled,
          kind: "checkbox",
          label: "Introduce New Cards",
          onCheckedChange: setIntroduceNewCardsEnabled,
          testID: "review-introduce-new-cards",
        },
      ]}
      side="top"
      sideOffset={8}
      trigger={
        <ToolbarIconButton
          accessibilityLabel="More review options"
          className="size-11 rounded-full shadow-xs"
          iconSize={22}
          name="FiMoreHorizontal"
          testID="learn-summary-review-options"
        />
      }
      triggerNativeID="More review options"
    />
  );
}
